import { BasePageableBuilder } from '@ravago/shared/page-data/builders/base';
import { AutoSuggestQueryArgs, AutoSuggestResponse } from '@ravago/shared/page-data/models/elastic';

export abstract class ElasticUtils {
  static async getAutosuggestResult(request: AutoSuggestQueryArgs, correlationId: string): Promise<AutoSuggestResponse> {
    const response = await fetch(`/api/elastic/auto-suggest?autosuggestArgs=${JSON.stringify({ args: request, correlationId })}`);

    if (response.ok) {
      return response.json();
    }
    return {
      searchResult: {
        content: [],
        ...BasePageableBuilder.aBasePageable().withPageIndex(0).withTotalNumberOfElements(0).withNumberOfElementsPerPage(request.size).build()
      },
      suggestedFilters: []
    };
  }
}
